<app-uni-page
  [parent]="this"
  pageTitle="Administration: QBO Test"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full">
    <!-- Toolbar -->
    <div class="qb-list-actions">
      <div class="flex items-center gap-3">
        <p-select
          [options]="statusFilterOptions"
          [(ngModel)]="selectedStatusFilter"
          optionLabel="label"
          class="w-48"
        ></p-select>
        <label class="text-sm">Count:</label>
        <input
          pInputText
          type="number"
          [(ngModel)]="invoiceCount"
          class="w-20 p-inputtext-sm"
          min="1"
          max="100"
        />
        <button
          pButton
          type="button"
          class="p-button-raised p-button-sm"
          icon="pi pi-refresh"
          [loading]="isLoading"
          (click)="loadInvoices()"
        >
          <span>Load Invoices</span>
        </button>
      </div>
      <div class="flex items-center gap-2">
        <button
          pButton
          type="button"
          class="p-button-raised p-button-sm p-button-warning"
          [icon]="actionButtonIcon"
          [disabled]="!canPostOrResync"
          [loading]="isLoading"
          (click)="postOrResyncInvoice()"
        >
          <span>{{ actionButtonLabel }}</span>
        </button>
      </div>
    </div>

    <!-- Grid -->
    <app-ag-grid [gridOptions]="gridOptions" [rowData]="invoices" class="flex-1 min-h-0"></app-ag-grid>

    <!-- Result Panel -->
    <div *ngIf="lastResult" class="p-3 border-t" [ngClass]="{
      'bg-green-50 border-green-200': lastResult.status === 'success',
      'bg-red-50 border-red-200': lastResult.status === 'error'
    }">
      <div class="font-semibold mb-1" [ngClass]="{
        'text-green-700': lastResult.status === 'success',
        'text-red-700': lastResult.status === 'error'
      }">
        {{ lastResult.status === 'success' ? 'Success' : 'Error' }}
      </div>
      <div class="text-sm">{{ lastResult.message }}</div>
      <div *ngIf="lastResult.glInvoiceId" class="text-sm mt-1">
        <strong>GL Invoice ID:</strong> {{ lastResult.glInvoiceId }}
      </div>
      <div *ngIf="lastResult.invoiceStatus" class="text-sm">
        <strong>Status:</strong> {{ lastResult.invoiceStatus }}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
